// Auto-generated normalizer for table: Roles_Recursos_Permisos
export function rolesRecursosPermisosNormalize(row) {
  return {
    idRolRecursoPermiso: row.idRolRecursoPermiso ?? row.IdRolRecursoPermiso ?? row['IdRolRecursoPermiso'] ?? 0,
    idRol: row.idRol ?? row.IdRol ?? row['IdRol'] ?? 0,
    idPermiso: row.idPermiso ?? row.IdPermiso ?? row['IdPermiso'] ?? 0,
    idRecurso: row.idRecurso ?? row.IdRecurso ?? row['IdRecurso'] ?? 0,
    fechaAsignacion: row.fechaAsignacion ?? row.FechaAsignacion ?? row['FechaAsignacion'] ?? null,
  };
}
